module.exports = __webpack_public_path__ + "img/double.dfb921a7.png";